export default __webpack_public_path__ + "static/media/robot1Body.fcdaf0aa.png";